var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentCreation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 229,
    height: 210,
    fill: "none",
    viewBox: "0 0 229 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M148.205 47.905h-1.108V17.562a17.572 17.572 0 0 0-5.143-12.418A17.563 17.563 0 0 0 129.536 0H65.249a17.562 17.562 0 0 0-17.561 17.562v166.465a17.56 17.56 0 0 0 17.561 17.562h64.287a17.562 17.562 0 0 0 17.561-17.562V69.504h1.108V47.905Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M130.25 4.568h-8.392a6.237 6.237 0 0 1-.597 5.829 6.23 6.23 0 0 1-5.172 2.756H79.261a6.23 6.23 0 0 1-5.77-8.585h-7.837A13.115 13.115 0 0 0 52.54 17.683v166.221a13.112 13.112 0 0 0 13.115 13.115h64.596a13.117 13.117 0 0 0 12.117-8.096c.659-1.591.998-3.296.998-5.019V17.684A13.116 13.116 0 0 0 130.25 4.567Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7691AD",
    d: "M85.558 208.261h-.831l1.661-111.073h.831L85.558 208.26Zm22.716 0h-.831l-1.662-111.073h.831l1.662 111.073Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7691AD",
    d: "M106.061 99.402h-19.39v.831h19.39v-.83Zm0 14.405h-19.39v.831h19.39v-.831Zm.55 14.402h-20.22v.831h20.22v-.831Zm.277 14.404H86.391v.831h20.497v-.831Zm.281 14.405H86.117v.831h21.052v-.831Zm-.005 14.402H85.836v.831h21.328v-.831Zm.281 14.404H85.563v.831h21.882v-.831Zm.276 14.405H85.008v.83h22.713v-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M95.442 151.302c6.427 0 11.637-5.211 11.637-11.638s-5.21-11.637-11.637-11.637c-6.427 0-11.637 5.21-11.637 11.637 0 6.427 5.21 11.638 11.637 11.638Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "m102.283 147.708-3.478.63 1.128 6.233 3.479-.63-1.129-6.233Zm-6.953 1.26-3.478.63 1.128 6.232 3.479-.629-1.129-6.233Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M94.825 157.14c1.241-1.052 1.928-2.282 1.534-2.747-.394-.466-1.72.009-2.962 1.06-1.242 1.052-1.929 2.282-1.535 2.747.395.466 1.721-.009 2.963-1.06Zm6.812-1.233c1.242-1.051 1.929-2.281 1.534-2.747-.394-.466-1.72.009-2.962 1.061-1.242 1.052-1.928 2.281-1.534 2.747.394.466 1.72-.009 2.962-1.061Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M94.626 140.794a3.977 3.977 0 1 0 0-7.954 3.977 3.977 0 0 0 0 7.954Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7691AD",
    d: "M92.99 136.718a1.326 1.326 0 1 0 0-2.652 1.326 1.326 0 0 0 0 2.652Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "M104.618 127.004c.175-4.308-3.538-7.957-8.294-8.15-4.755-.193-8.752 3.142-8.927 7.451-.175 4.308 3.13 5.287 7.886 5.48 4.755.193 9.16-.473 9.335-4.781Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M90.368 138.845c.226-.983-2.13-2.363-5.263-3.081-3.132-.717-5.854-.502-6.08.481-.225.983 2.131 2.362 5.264 3.08 3.132.718 5.854.503 6.08-.48Zm22.844 3.799c.225-.984-2.131-2.363-5.263-3.081-3.133-.718-5.855-.503-6.08.481-.225.983 2.131 2.362 5.263 3.08 3.133.718 5.855.503 6.08-.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M98.639 144.25a2.652 2.652 0 1 1-5.217.949l-.001-.005c-.261-1.441.853-1.951 2.294-2.211 1.441-.261 2.663-.174 2.924 1.267Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "m135.568 70.699-74.49 6.676a1.387 1.387 0 0 1-1.503-1.256L57.92 57.642a1.387 1.387 0 0 1 1.256-1.504l74.49-6.676a1.386 1.386 0 0 1 1.503 1.256l1.656 18.478a1.39 1.39 0 0 1-1.256 1.503ZM59.225 56.69a.832.832 0 0 0-.754.902l1.656 18.478a.832.832 0 0 0 .902.753l74.49-6.676a.832.832 0 0 0 .753-.902l-1.656-18.477a.832.832 0 0 0-.902-.754l-74.49 6.676Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7691AD",
    d: "M69.778 71.708a5.817 5.817 0 1 0 0-11.634 5.817 5.817 0 0 0 0 11.634Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M82.813 60.83a.967.967 0 0 0-.88 1.052.969.969 0 0 0 1.053.879l45.521-4.08a.97.97 0 0 0 .535-1.71.967.967 0 0 0-.708-.221l-45.521 4.08Zm.519 5.795a.97.97 0 1 0 .173 1.93l45.521-4.079a.969.969 0 0 0-.173-1.931l-45.52 4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M108.378 75.039c1.176-3.077 1.346-5.87.38-6.24-.966-.37-2.702 1.826-3.878 4.903-1.177 3.077-1.347 5.87-.381 6.24.966.37 2.703-1.826 3.879-4.903Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M107.376 85.29c1.055-6.503-3.362-12.63-9.865-13.686-6.503-1.055-12.63 3.362-13.686 9.865-1.055 6.503 3.361 12.63 9.864 13.686 6.504 1.055 12.631-3.361 13.687-9.864Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M93.788 92.742h-3.624v6.493h3.624v-6.493Zm7.25 0h-3.624v6.493h3.624v-6.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M93.184 100.443c1.668 0 3.02-.507 3.02-1.133 0-.625-1.352-1.132-3.02-1.132s-3.02.507-3.02 1.132c0 .626 1.352 1.133 3.02 1.133Zm7.25-.151c1.668 0 3.02-.507 3.02-1.132 0-.626-1.352-1.133-3.02-1.133s-3.02.507-3.02 1.133c0 .625 1.352 1.132 3.02 1.132Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "M84.028 72.286c-.963-4.314 2.116-8.673 6.877-9.736 4.762-1.063 9.403 1.572 10.366 5.886.963 4.314-2.193 5.905-6.954 6.968-4.761 1.063-9.326 1.196-10.29-3.118Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M87.558 80.4c.443-.934-1.611-2.836-4.587-4.247-2.977-1.412-5.749-1.799-6.192-.864-.443.934 1.61 2.836 4.587 4.248 2.976 1.411 5.748 1.798 6.192.864ZM23.726 204.335c6.589 0 11.93-5.341 11.93-11.929s-5.341-11.929-11.93-11.929c-6.588 0-11.93 5.341-11.93 11.929s5.342 11.929 11.93 11.929Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M21.913 201.768H18.29v6.493h3.624v-6.493Zm7.25 0H25.54v6.493h3.624v-6.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M21.31 209.468c1.667 0 3.02-.507 3.02-1.132 0-.626-1.353-1.133-3.02-1.133-1.669 0-3.02.507-3.02 1.133 0 .625 1.351 1.132 3.02 1.132Zm7.25-.15c1.667 0 3.02-.507 3.02-1.133 0-.625-1.353-1.132-3.02-1.132-1.669 0-3.02.507-3.02 1.132 0 .626 1.351 1.133 3.02 1.133Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.03 193.463a4.077 4.077 0 1 0 0-8.155 4.077 4.077 0 0 0 0 8.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7691AD",
    d: "M24.03 190.743a1.359 1.359 0 1 0 .002-2.718 1.359 1.359 0 0 0-.001 2.718Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M12.153 181.311c-.963-4.313 2.116-8.672 6.877-9.736 4.762-1.063 9.403 1.572 10.366 5.886.963 4.314-2.193 5.905-6.954 6.968-4.762 1.063-9.326 1.196-10.29-3.118Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M32.425 149.787c1.176-3.077 1.346-5.871.38-6.24-.966-.369-2.702 1.826-3.879 4.903-1.176 3.077-1.346 5.871-.38 6.24.966.369 2.703-1.826 3.879-4.903Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M31.43 160.039c1.056-6.504-3.36-12.631-9.864-13.687-6.503-1.055-12.631 3.362-13.686 9.865-1.056 6.503 3.36 12.631 9.864 13.686 6.503 1.055 12.63-3.361 13.686-9.864Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M17.843 167.49h-3.624v6.493h3.624v-6.493Zm7.242 0h-3.624v6.493h3.624v-6.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M17.239 175.191c1.668 0 3.02-.507 3.02-1.133 0-.625-1.352-1.132-3.02-1.132s-3.02.507-3.02 1.132c0 .626 1.352 1.133 3.02 1.133Zm7.242-.151c1.668 0 3.02-.507 3.02-1.132 0-.626-1.352-1.133-3.02-1.133s-3.02.507-3.02 1.133c0 .625 1.352 1.132 3.02 1.132Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.952 159.184a4.078 4.078 0 1 0-.001-8.155 4.078 4.078 0 0 0 .001 8.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7691AD",
    d: "M19.953 156.466a1.359 1.359 0 1 0 0-2.717 1.359 1.359 0 0 0 0 2.717Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "M8.083 147.034c-.964-4.314 2.115-8.673 6.877-9.736 4.761-1.063 9.402 1.572 10.366 5.886.963 4.314-2.193 5.905-6.954 6.968-4.762 1.063-9.326 1.196-10.29-3.118Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M11.604 155.149c.444-.935-1.61-2.836-4.586-4.248-2.977-1.412-5.749-1.799-6.192-.864-.443.934 1.61 2.836 4.587 4.248 2.976 1.411 5.748 1.798 6.191.864Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.79 162.43c0 1.168 3.005 3.473 6.341 3.473 3.336 0 6.464-3.287 6.464-4.455 0-1.167-3.128.227-6.464.227-3.336 0-6.342-.413-6.342.755Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M70.94 158.408c1.176-3.077 1.347-5.871.38-6.24-.965-.369-2.702 1.826-3.878 4.903-1.176 3.077-1.346 5.871-.38 6.24.966.369 2.702-1.826 3.878-4.903Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M72.438 171.152c1.055-6.503-3.361-12.631-9.864-13.686-6.504-1.056-12.631 3.361-13.687 9.864-1.055 6.503 3.361 12.631 9.865 13.686 6.503 1.056 12.63-3.361 13.686-9.864Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M55.227 178.602h3.623l-.709 7.775-2.914-1.282v-6.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M58.285 188.663c.55-.296.358-1.727-.431-3.197-.79-1.469-1.875-2.421-2.426-2.125-.552.296-.359 1.727.43 3.197.79 1.469 1.876 2.421 2.427 2.125Zm4.84-10.04h3.624l-.709 7.776-2.915-1.283v-6.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M66.191 188.682c.551-.296.358-1.727-.43-3.196-.79-1.47-1.876-2.421-2.427-2.125-.551.296-.358 1.727.43 3.196.79 1.47 1.876 2.421 2.427 2.125Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60.96 170.297a4.077 4.077 0 1 0 0-8.155 4.077 4.077 0 0 0 0 8.155Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7691AD",
    d: "M60.96 167.579a1.359 1.359 0 1 0 .001-2.717 1.359 1.359 0 0 0 0 2.717Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M49.09 158.145c-.963-4.313 2.116-8.672 6.878-9.736 4.761-1.063 9.402 1.572 10.365 5.886.963 4.314-2.192 5.905-6.954 6.968-4.761 1.063-9.325 1.196-10.289-3.118Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E475D",
    d: "M51.602 165.733c.831-.614-.08-3.26-2.038-5.91-1.957-2.65-4.218-4.3-5.05-3.685-.832.614.08 3.26 2.038 5.91 1.957 2.65 4.218 4.3 5.05 3.685Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M66.476 175.392c0-.963-2.478-2.863-5.227-2.863-2.75 0-5.327 2.709-5.327 3.672 0 .962 2.578-.187 5.327-.187 2.75 0 5.227.34 5.227-.622Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7691AD",
    d: "M53.986 159.253a26.291 26.291 0 0 1-18.61-7.704 26.295 26.295 0 0 1-7.7-18.778c.08-14.41 11.883-26.146 26.31-26.146a26.316 26.316 0 0 1 25.622 20.318 26.317 26.317 0 0 1-13.937 29.581 26.058 26.058 0 0 1-11.685 2.729Zm0-52.074a25.813 25.813 0 0 0-25.757 25.609c-.003.059-.003.107-.003.151a25.763 25.763 0 0 0 24.024 25.709 25.76 25.76 0 0 0 27.263-22.244 25.754 25.754 0 0 0-25.527-29.225Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "m65.904 134.213-18.01-10.399a.56.56 0 0 0-.554 0 .56.56 0 0 0-.278.48v20.797a.554.554 0 0 0 .832.48l18.01-10.399a.55.55 0 0 0 .203-.756.56.56 0 0 0-.203-.203l-18.01-10.399a.56.56 0 0 0-.554 0 .56.56 0 0 0-.278.48v20.797a.554.554 0 0 0 .832.48l18.01-10.399a.55.55 0 0 0 .203-.756.56.56 0 0 0-.203-.203Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M63.68 207.708c8.108 0 14.681-.248 14.681-.554 0-.306-6.573-.554-14.68-.554-8.108 0-14.681.248-14.681.554 0 .306 6.573.554 14.68.554Zm150.407-5.264c8.108 0 14.68-.248 14.68-.554 0-.306-6.572-.554-14.68-.554s-14.681.248-14.681.554c0 .306 6.573.554 14.681.554Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "m214.012 201.423-65.832-35.49a1.387 1.387 0 0 1-.562-1.876l8.804-16.33a1.387 1.387 0 0 1 1.876-.562l65.832 35.489a1.387 1.387 0 0 1 .561 1.877l-8.803 16.33a1.39 1.39 0 0 1-1.876.562Zm-55.977-53.77a.832.832 0 0 0-1.126.337l-8.803 16.33a.835.835 0 0 0 .337 1.126l65.832 35.489a.833.833 0 0 0 1.125-.337l8.804-16.33a.835.835 0 0 0-.337-1.126l-65.832-35.489Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5906",
    d: "M161.778 166.968a5.818 5.818 0 1 0-.002-11.636 5.818 5.818 0 0 0 .002 11.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M175.438 164.112a.978.978 0 0 0-.739-.075.952.952 0 0 0-.575.469.96.96 0 0 0-.075.738.952.952 0 0 0 .469.575l40.23 21.688a.978.978 0 0 0 .738.075.956.956 0 0 0 .576-.468.978.978 0 0 0 .075-.739.984.984 0 0 0-.469-.575l-40.23-21.688Zm-2.758 5.119a.97.97 0 0 0-.921 1.707l40.231 21.688a.979.979 0 0 0 .738.075.969.969 0 0 0 .182-1.782l-40.23-21.688Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.766 0h228v209.469h-228z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCreation);
export default __webpack_public_path__ + "static/media/content_creation.e78defd2e87e15b6d1a1ebe2879d0074.svg";
export { ForwardRef as ReactComponent };